import { Box, Typography, styled } from '@mui/material';

import { PrimaryButton } from '../../../shared/buttons';

export const PageContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
  overflowY: 'auto',
  padding: '40px 20px'
}));

export const ContentCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  maxWidth: '900px',
  width: '100%',
  backgroundColor: theme.palette.common.white,
  borderRadius: 8,
  border: `1px solid ${theme.palette.divider}`,
  overflow: 'hidden'
}));

export const LeftPanel = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '40px 30px',
  borderRight: `1px solid ${theme.palette.divider}`
}));

export const RightPanel = styled(Box)({
  flex: 1,
  padding: '40px 30px'
});

export const Heading = styled(Typography)({
  fontWeight: 700,
  textAlign: 'center',
  marginBottom: '10px',
});

export const Heading2 = styled(Typography)({
  fontWeight: 700,
  textAlign: 'center',
  marginBottom: '10px',
  marginTop: '20px'
});

export const BenefitsHeading = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.text.primary,
  marginTop: '16px',
  marginBottom: '8px'
}));

export const BenefitsList = styled('ul')(({ theme }) => ({
  paddingLeft: '20px',
  margin: '0 0 16px 0',
  '& li': {
    fontSize: '14px',
    color: theme.palette.text.primary,
  }
}));

export const InfoText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 700,
  '& a': {
    color: '#0675DD',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}));

export const EnrollButton = styled(PrimaryButton)({
  width: '280px',
  padding: '10px 24px',
});

export const LogoContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '20px',
  gap: '10px'
});

export const LogoText = styled(Typography)(({ theme }) => ({
  fontSize: '32px',
  fontWeight: 700,
  color: theme.palette.text.primary,
  fontFamily: 'Arial'
}));
